// state
const state = () => ({
    usuarioPro: false,
    token: ''
  });
  
  // getters
  const getters = {
    getUsuarioPro: (state) => {
      return state.usuarioPro;
    },
    getToken: (state) => {
      return state.token
    }
  };
  
  // mutations
  const mutations = {
    SET_USUARIO_PRO (state, usuarioPro) {
      state.usuarioPro = usuarioPro
    },
    SET_TOKEN (state, token) {
      state.token = token
    }
  }
  
  // actions
  const actions = {
    setUsuarioPro ({ commit }, usuarioPro) {
      commit('SET_USUARIO_PRO', usuarioPro)
    },
    setToken ({ commit }, token) {
      commit('SET_TOKEN', token)
    }
  }
  
  export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
  